import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  return useIsNarrowScreen(MOBILE_BREAKPOINT);
}

export function useIsNarrowScreen(breakpoint: number) {
  const [isNarrow, setIsNarrow] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const sync = () => setIsNarrow(mql.matches);
    // iOS sends no change event to a backgrounded Home Screen web app, so a width it passed through
    // while away would stick until a reload. Check again whenever the page comes back.
    const onVisible = () => {
      if (document.visibilityState === "visible") sync();
    };
    mql.addEventListener("change", sync);
    window.addEventListener("resize", sync);
    window.addEventListener("pageshow", sync);
    document.addEventListener("visibilitychange", onVisible);
    sync();
    return () => {
      mql.removeEventListener("change", sync);
      window.removeEventListener("resize", sync);
      window.removeEventListener("pageshow", sync);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [breakpoint]);

  return !!isNarrow;
}
